import { render, staticRenderFns } from "./UploadCsv.vue?vue&type=template&id=5332204e&scoped=true"
import script from "./UploadCsv.vue?vue&type=script&lang=js"
export * from "./UploadCsv.vue?vue&type=script&lang=js"
import style0 from "./UploadCsv.vue?vue&type=style&index=0&id=5332204e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332204e",
  null
  
)

export default component.exports